import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { CreatePostsGroupDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import GroupForm from 'modules/dashboard/components/GroupForm'
import groups from 'modules/dashboard/store/collections/communities/Groups'

interface Props {
  onClose: () => void
}

function NewGroup({ onClose }: Props) {
  const { company } = useCurrentSession()
  const [createPostsGroup] = useMutation(CreatePostsGroupDocument, {
    extractorFn: (data) => data.postsMutations.createPostsGroup,
  })

  const form = React.useRef(
    new Form(
      {
        title: null,
        description: null,
      },
      {
        title: 'string',
        description: 'string',
      }
    )
  ).current

  const submit = async (closePortal: ClosePortalFn) => {
    const result = await createPostsGroup({
      variables: {
        companyId: company.id,
        title: form.get('title').value,
        description: form.get('description').value,
      },
    })
    groups.fetch()

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      closePortal()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('common.forbidden'),
        time: 2000,
      })
      closePortal()
    }

    return handled
  }

  const disabled = !form.get('title').value || !form.get('description').value

  return (
    <Modal
      description={i18n.t('dashboard.groups.new.description')}
      illustration="people-add"
      onClose={onClose}
      onSubmit={submit}
      title={i18n.t('dashboard.groups.new.title')}
      footer={
        <Button disabled={disabled} submit>
          {i18n.t('dashboard.groups.new.title')}
        </Button>
      }
    >
      <GroupForm form={form} />
    </Modal>
  )
}

export default observer(NewGroup)
